export default "__VITE_ASSET__DsY1x1qv__"